import Runass from '../../views/Runass';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickAssessHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/viewReport`));
    },

    clickBackHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/assesment`));
    },

    clickFAQHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/faqpage`));
    }
  };
};

const RunassComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Runass);

export default RunassComponent;



// WEBPACK FOOTER //
// ./src/components/container/Runass/index.js